import { formatAddressString } from '@/utils/address';
import useUserProfileData from '@montugroup/circuit-shared/hooks/user/useGetUserProfile';
import { useMemo } from 'react';
import { useAddressGeometryQuery } from './useAddressGeometryQuery';
import { userAddressToAddress } from './useClickAndCollectLocationQuery';

export function useUserAddressGeometryQuery() {
  const { data: userProfileData, getUserState } = useUserProfileData();
  const userAddressAsAddress = useMemo(() => {
    if (!userProfileData?.user) {
      return;
    }

    return userAddressToAddress(userProfileData.user, getUserState);
  }, [userProfileData?.user, getUserState]);
  const userAddressAsString = userAddressAsAddress && formatAddressString(userAddressAsAddress);
  return useAddressGeometryQuery(userAddressAsString);
}
